<template>
    <div class="product-list">
        <div v-for="product in data" class="col-md-4">
            <div class="product-item">
                <a href="javascript:void(0);" @click="itemClick(product)">
                    <div class="product-item-img">
                        <img :src="product.product_img" class="img-responsive" :alt="product.product_name">
                    </div>
                    <div class="product-item-info">
                        <h5>{{product.product_name}}</h5>
                    </div>
                </a>
            </div>
        </div>
        <!-- 清除浮动 -->
        <div class="clearfix"></div>
    </div>
</template>

<script>
    export default {
        name: "list",
        props: ['data'],
        methods:{
            itemClick(item){
                this.$emit("itemClick",item);
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/product/List.vue